/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Description_InfocardInputs */

const es_tyc_description_infocard = /** @type {(inputs: Tyc_Description_InfocardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata no almacena sus datos de origen. Actua como una capa de acceso y procesamiento que respeta los permisos y configuraciones de las fuentes conectadas.`)
};

const en_tyc_description_infocard = /** @type {(inputs: Tyc_Description_InfocardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata does not store your source data. It acts as an access and processing layer that respects the permissions and configurations of connected sources.`)
};

/**
* | output |
* | --- |
* | "Nexata does not store your source data. It acts as an access and processing layer that respects the permissions and configurations of connected sources." |
*
* @param {Tyc_Description_InfocardInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_description_infocard = /** @type {((inputs?: Tyc_Description_InfocardInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Description_InfocardInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_description_infocard(inputs)
	return en_tyc_description_infocard(inputs)
});
export { tyc_description_infocard as "tyc.description.infocard" }